import { MultiInputStreamVisitor } from './multi-input-stream.visitor';
import { SortExpressionPlainObject } from '../plainObjects/sortExpression.plainObject';
import { LookupPlainObject } from '../plainObjects/lookup.plainObject';

export class LookupVisitor extends MultiInputStreamVisitor {
    private get _lookupTransformation(): LookupPlainObject {
        return this.transformation as LookupPlainObject;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public visitBasicFunction(context: any): any {
        const sortExpression = new SortExpressionPlainObject();
        const expressions = context.expression();
        sortExpression.ascending = this._getText(context.basicName()) === 'asc';
        sortExpression.expression = expressions[0] ? this._getText(expressions[0]) : '';
        sortExpression.nullsFirst = expressions[1] && this._getText(expressions[1]) === 'true';
        this._lookupTransformation.sortExpressions.push(sortExpression);
    }
}
